import { newAxiosIns } from '@/libs/axios'

export function apiGetProuctList({ keyword, page, limit }) {
  const params = {
    keyword,
    page,
    limit,
  }
  return newAxiosIns.get('komship/api/v1/komchat/product', { params })
}
export function apiGetProuctLists({ keyword, page, limit }) {
  const params = {
    keyword,
    page,
    limit,
  }
  return newAxiosIns.get('/api/v1/product', { params })
}
